import React from 'react';
import { Chip, Stack } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { uniqueOrderedCodes } from './StatementXmlPreview.utils';
import type { StatementSentenceRow } from './types';

type StatementXmlPreviewCodesOnlyProps = {
  rows: StatementSentenceRow[];
  sx?: SxProps<Theme>;
};

export const StatementXmlPreviewCodesOnly: React.FC<StatementXmlPreviewCodesOnlyProps> = ({ rows, sx }) => {
  const orderedCodes = uniqueOrderedCodes(rows, true);

  return (
    <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap" sx={sx}>
      {orderedCodes.map((code) => (
        <Chip key={code} size="small" color="warning" label={code} />
      ))}
    </Stack>
  );
};
